import { Badge, BadgeProps } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type BadgeErrorProps = {
  className?: string;
  children: React.ReactNode;
} & BadgeProps;

export const BadgeError = ({
  className,
  children,
  ...props
}: BadgeErrorProps) => {
  return (
    <Badge
      variant='outline'
      className={cn(
        'bg-brand-red/10 text-brand-red rounded-full border-0 px-3 py-2 md:px-2 md:py-1.5',
        className,
      )}
      {...props}
    >
      <p className='flex items-center gap-1 overflow-hidden text-ellipsis whitespace-nowrap text-xs font-normal leading-4 md:font-medium'>
        {children}
      </p>
    </Badge>
  );
};
